import { Button, Table, Tag } from 'antd'
import React from 'react'
import '../myHrManage.scss'

const ContractTable = ({ data, onView, isChief = false }) => {
  const columns = [
    {
      title: '서명상태',
      dataIndex: 'status',
      key: 'status',
      width: 90, // 💡 고정 너비 부여 (작게)
      align: 'center', // 💡 중앙 정렬
      render: (status, record) => {
        const isCertificate =
          record?.itemType === 'CERTIFICATE' ||
          record?.contractType === 'CERTIFICATE'
        const displayStatus = isCertificate ? '완료' : status
        if (displayStatus === '진행중') {
          return (
            <Tag
              className="contract-status-tag contract-status-progress"
              color="#E6F2FF"
            >
              <span style={{ color: '#007AFF' }}>진행중</span>
            </Tag>
          )
        }
        if (displayStatus === '완료') {
          return (
            <Tag
              className="contract-status-tag contract-status-completed"
              color="#E6F9F0"
            >
              <span style={{ color: '#10B981' }}>완료</span>
            </Tag>
          )
        }
        return <span>{status}</span>
      },
    },
    {
      title: '서명 요청일',
      dataIndex: 'requestDate',
      key: 'requestDate',
      width: 110, // 💡 날짜가 들어갈 최소 너비
      align: 'center',
    },
    {
      title: '기한',
      dataIndex: 'deadline',
      key: 'deadline',
      width: 80, // 💡 기한은 짧으므로 좁게
      align: 'center',
    },
    {
      title: '계약서 명',
      dataIndex: 'contractName',
      key: 'contractName',
      // 💡 width를 주지 않음 -> 남은 공간을 얘가 다 차지함
      ellipsis: true, // 공간이 부족하면 ... 처리 (안전장치)
      align: 'center',
    },
    {
      title: '처리',
      key: 'action',
      width: 110, // 💡 버튼 들어갈 고정 너비
      align: 'center',
      render: (_, record) => {
        const handleClick = () => {
          // API에서 내려온 계약 정보(및 상위에서 매핑한 필드)를 그대로 전달
          onView?.(record)
        }

        const isPending = record.status === '진행중'
        const buttonLabel = isChief
          ? '문서 보기'
          : isPending
            ? '서명하기'
            : '문서 보기'

        return (
          <Button
            className={`contract-action-btn ${
              isPending
                ? 'contract-action-btn-progress'
                : 'contract-action-btn-completed'
            }`}
            onClick={handleClick}
          >
            {buttonLabel}
            <span className="contract-action-arrow"> &gt;</span>
          </Button>
        )
      },
    },
  ]

  return (
    <div className="contract-table-wrapper">
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{ y: '165px' }} // 💡 세로 스크롤은 유지
        // tableLayout="fixed" // 💡 필요시 주석 해제 (강제로 너비 맞춤)
      />
    </div>
  )
}

export default ContractTable
